import { IconDownload } from '@/components/standard/my-icons'

export default {
  name: 'my-download-button',
  template: `
    <a :href="href" @click="downloadClicked()" target="_blank" class="o-link--btn o-link--icon">
      <span class="o-link--icon__text"><slot>Download full section PDF</slot></span>
      <icon-download class="o-link--icon__icon"></icon-download>
    </a>
  `,
  components: {
    IconDownload
  },
  props: {
    section: {
      type: String,
      default: 'ukpn-annual-review-2017'
    }
  },
  computed: {
    href () {
      return require('@/assets/pdfs/' + this.section + '.pdf')
    }
  },
  methods: {
    downloadClicked () {
      window.gtag('event', 'pdf_downloaded', { 'event_label': this.section, 'type': 'button' })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/standard/my-download-button.js